import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import './style.css'

// Routes
const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('./components/FacilityLogin.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('./components/MainDashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/arrival',
    name: 'Arrival',
    component: () => import('./components/ArrivalScreen.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/departure',
    name: 'Departure',
    component: () => import('./components/DepartureScreen.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/reports',
    name: 'Reports',
    component: () => import('./components/ReportsScreen.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('./components/SettingsScreen.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guard for auth
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('facility_token')

  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else if (to.path === '/login' && token) {
    next('/dashboard')
  } else {
    next()
  }
})

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.mount('#app')
